import { defineMessage } from 'react-intl';

export const settingsI18n = {
  accountSettingsHeading: defineMessage({
    id: 'heading.account-settings',
    defaultMessage: 'Account settings'
  }),

  childProfiles: {
    heading: defineMessage({
      id: 'settings.family-members.heading',
      defaultMessage: 'Family members'
    }),
    description: defineMessage({
      id: 'settings.family-members.description',
      defaultMessage: 'Manage family members to help organize their bookings'
    })
  },
  payments: {
    heading: defineMessage({
      id: 'settings.payments.heading',
      defaultMessage: 'Payments'
    }),
    description: defineMessage({
      id: 'settings.payments.description',
      defaultMessage: 'Add or remove payment methods'
    })
  },
  personalInfo: {
    heading: defineMessage({
      id: 'settings.personal-info.heading',
      defaultMessage: 'Personal info'
    }),
    description: defineMessage({
      id: 'settings.personal-info.description',
      defaultMessage: 'Provide personal details and how we can reach you'
    })
  },
  security: {
    heading: defineMessage({
      id: 'settings.security.heading',
      defaultMessage: 'Login and security'
    }),
    description: defineMessage({
      id: 'settings.security.description',
      defaultMessage: 'Update your password and secure your account'
    })
  }
};
